module.exports = __webpack_public_path__ + "media/iphone.711770d9.mp3";